import changeThemeDark from '../../images/docs/theme-sign-theme-edit.png';
import changeThemeLight from '../../images/docs/theme-sign-theme-edit-white.png';

export const meta = {
  slug: 'tema',
  title: 'Temă',
  description: 'Cum să schimbați tema de culoare a platformei între modul întunecat și cel luminos.',
  icon: 'moon',
  order: 2,
  related: ['introducere', 'cont'],
};

export const images = { changeThemeDark, changeThemeLight };

export const content = `
## Temă

Pentru a schimba tema de culoare al întregului program tot ce trebuie să faceți este să dați click pe butonul cu soare/lună din colțul dreapta de sus al ecranului.
`;
